const currencies: { [key: string]: { [key: string]: string } } = {
	bs: {
		BAM: 'KM',
		USD: '$',
	},
	en: {},
};

export default currencies;
